'use client';

import { useIsMobile } from '@/hooks/use-mobile';
import { Plus } from 'lucide-react';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
function AddNewPayment() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();
  const PaymentMethodDrawer = dynamic(() => import('./payment-method-selector-drawer').then(module_ => module_.PaymentMethodDrawer), {
    ssr: false
  });
  const PaymentMethodModal = dynamic(() => import('./payment-method-selector-modal').then(module_ => module_.PaymentMethodModal), {
    ssr: false
  });
  return <>
      <button type="button" onClick={() => setIsOpen(true)} className="flex w-full items-center justify-between gap-3 rounded-xl bg-white px-4 py-3 text-x-accent-alpha">
        <span>Add new</span>
        <Plus className="size-5" data-sentry-element="Plus" data-sentry-source-file="add-new-payment.tsx" />
      </button>

      {isMobile ? <PaymentMethodDrawer open={isOpen} onOpenChange={setIsOpen} /> : <PaymentMethodModal open={isOpen} onOpenChange={(status: boolean) => setIsOpen(status)} />}
    </>;
}
;
export default AddNewPayment;